<template>
  <main>
    <contact-us-blurb />
    <div class="container-fluid bg-white py-5">
      <div
        class="container"
        style="text-align:center;"
      >
        <h2>You do not have access to this section.</h2>
        <router-link
          class="nav-link"
          :to="{name: 'subscriptions'}"
        >
          Add a Subscription to your Account
        </router-link>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'NoAccess',
  data() {
    return {

    }
  }
}
</script>